import { render } from "./publicpage.vue?vue&type=template&id=347bf2a3"
import script from "./publicpage.vue?vue&type=script&lang=js"
export * from "./publicpage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__